<!--
 * @Descripttion: 内部福利
 * @Author: jschen
 * @Date: 2021-08-29 17:26:02
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-12 14:52:07
-->
<template>
    <div>
        <div class="inside-welfare--page">
            <div class="system-box house-table-box">
                <header class="top-header">
                    <div class="breadcrumb">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="{ path: '/work-portal/user-center' }">
                                <i class="icon-home"></i> 个人中心
                            </el-breadcrumb-item>
                            <el-breadcrumb-item>内部福利</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </header>
                <div class="center-context">
                    <img :src="imgSrc" width="100%" height="100%" alt="" />
                </div>
            </div>
        </div>
        <div class="inside-footer">
            <div class="welfare-box">
                <div class="title">员工福利相关制度：</div>
                <div class="welfare-list">
                    <span v-for="(item, index) in data" :key="index" @click="openSystem(item.ssoUrl)"
                        ><span class="title-item">《{{ item.systemName }}》</span
                        ><span v-show="index !== data.length - 1">、</span></span
                    >
                </div>
            </div>
            <div class="welfare-icon" @click="openSystem(hrUrl)">
                <img src="@/assets/pics/user-center/hr-servie.png" alt="新希望地产HR服台" />
                <span>新希望地产HR服务台</span>
            </div>
        </div>
    </div>
</template>
<script>
import { getInternalBenefits } from "@/api";
export default {
    name: "InsideWelfare",
    components: {},
    data() {
        return {
            imgSrc: require("@/assets/pics/user-center/nbfl.png"),
            reqParams: {
                current: 1,
                size: 100,
            },
            hrUrl: "https://applink.feishu.cn/TdYqCv1D",
            data: [],
        };
    },
    mounted() {
        this.getCategoryList();
    },
    activated() {
        this.getCategoryList();
    },
    methods: {
        // 获取内部福利
        async getCategoryList() {
            try {
                const { code, body, message } = await getInternalBenefits({ ...this.reqParams });
                if (code === "0000") {
                    this.data = body ? body.records : [];
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error("系统错误");
            }
        },

        openSystem(url) {
            window.open(url);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
